import { forwardRef } from "react";
import classNames from "classnames/bind";
import { VideoEmbed } from "@components";
import { VideoCarouselFragment } from "@graphqlTypes";

import styles from './VideoCarousel.module.scss';
const cx = classNames.bind(styles);

type Props = VideoCarouselFragment['videos'][number];

const VideoCarouselItem = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { videoEmbed, title } = props;
  // console.log(videoEmbed, 'in carousel item');
  return (
    <button className={cx(["video-carousel-item", "splide__slide"])} ref={ref} aria-label={`Play video: ${title}`}>
      <VideoEmbed {...videoEmbed} playVideoLabel={title} debug />
      <h3 className={cx(["title-lc-s"])}>{title}</h3>
    </button>
  );
});

export default VideoCarouselItem;
